export default __webpack_public_path__ + "static/media/11.9e416953.webp";